import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593dcc7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("LEAGUES Creator")
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("TabsPage ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Karten erstellen ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Profil ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_upload_progress = _resolveComponent("upload-progress")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, {
        class: "split-pane",
        "content-id": "main"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            disabled: !_ctx.userLoggedIn,
            "content-id": "main",
            "menu-id": "app-menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_button, {
                            "auto-hide": "false",
                            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/'))
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "primary" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                ios: "ellipsis-horizontal",
                                md: "ellipsis-vertical"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, { size: "small" }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      (_ctx.badgeUrl)
                        ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                            key: 0,
                            slot: "end",
                            onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/switchclub', 'forward', 'replace'))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", { src: _ctx.badgeUrl }, null, 8, _hoisted_2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  (this.router)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            class: _normalizeClass({active: '/tabs/' === this.router.currentRoute.matched[0].path}),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routerFunction('/tabs/')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_ion_item, {
                            class: _normalizeClass({active: '/cards/' === this.router.currentRoute.matched[0].path}),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routerFunction('/cards/')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_ion_item, {
                            class: _normalizeClass({active: '/tabs/' === this.router.currentRoute.matched[0].path}),
                            onClick: _cache[4] || (_cache[4] = () => _ctx.routerFunction('/tabs/tab2'))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_ion_router_outlet, { id: "main" })
        ]),
        _: 1
      }),
      (_ctx.showUpload)
        ? (_openBlock(), _createBlock(_component_upload_progress, {
            key: 0,
            uploadProgress: _ctx.uploadProgress
          }, null, 8, ["uploadProgress"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}